import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { AuthService } from "app/auth/auth.service";
import { ReportExecutionService } from "providers/report-execution-service/report-execution.service";
import { UtilityService } from "providers/utility-service/utility-service";

@Component({
  selector: "quicksight-dashboard-report",
  templateUrl: "quicksight-dashboard-report.html",
})
export class QuicksightDashboardReportPage implements OnInit {
  @Input() dashboardName: string;
  @Input() parameters: any;
  @Input() dashboardTitle: string;

  loadingDashboard = false;

  quicksightDashboardUrl: SafeResourceUrl;

  constructor(
    private reportExecutionService: ReportExecutionService,
    private domSanitizer: DomSanitizer,
    private utilityService: UtilityService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.getQuickSightDashboard();
  }

  async getQuickSightDashboard(retryCount = 0) {
    const maxRetries = 1;

    this.loadingDashboard = true;

    let payload = {
      dashboard_name: this.dashboardName,
      parameters: this.parameters,
      username: this.authService.getUser().tenantId.toString(),
      id_token: await this.authService.getValidIdToken(),
      email: this.authService.getUser().email,
    };

    this.reportExecutionService.increaseSpinnerCount();
    this.reportExecutionService
      .getQuicksightDashboardAPIForRegisteredUser(payload)
      .subscribe(
        (response) => {
          if (response) {
            this.quicksightDashboardUrl =
              this.domSanitizer.bypassSecurityTrustResourceUrl(
                response.toString()
              );
          } else {
            this.utilityService.presentCustomErrorToast(
              "Cannot get Quicksight Dashboard."
            );
          }
          this.reportExecutionService.decreaseSpinnerCount();
          this.loadingDashboard = false;
        },

        (err) => {
          console.error("Error: QuickSight Dashboard. ", err);
          if (
            err &&
            err.message &&
            err.message.includes(
              "operation error Cognito Identity: GetId, https response error StatusCode: 400"
            ) &&
            retryCount <= maxRetries
          ) {
            this.reportExecutionService.increaseSpinnerCount();
            this.getQuickSightDashboard(retryCount + 1);
            this.reportExecutionService.decreaseSpinnerCount();
          } else {
            this.reportExecutionService.decreaseSpinnerCount();
            this.utilityService.presentCustomErrorToast(
              "Failed to retrieve QuickSight Dashboard."
            );
            this.loadingDashboard = false;
          }
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-managment/reports/quicksight-dashboard-report/quicksight-dashboard-report.ts